import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { getCountdown } from "../helper/Countdown";
import { addToCart } from "../helper/cartfunction";

const ProductDetailsOne = ({ data }) => {
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  console.log("Data in the product cateogry page", data);
  

  const calculateDiscountedPrice = (price, discount, discountType) => {
    if (discountType === "amount") {
      return price - discount;
    }
    if (discountType === "percent") {
      return price - (price * discount) / 100;
    }
    return price;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
 
  const [quantity, setQuantity] = useState(1);
  const incrementQuantity = () => setQuantity(quantity + 1);
  const decrementQuantity = () => setQuantity(quantity > 1 ? quantity - 1 : quantity);
 
  const settingsThumbs = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
  };
  return (
    <section className="product-details py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-lg-12 px-20">
            <div className="row gy-4">
              <div className="col-lg-4">
                <div className="product-details__left">
                  <div className="product-details__thumb-slider border border-gray-100 rounded-16">
                    <div className="">
                      <div className="product-details__thumb flex-center h-100 p-0">
                      <img src={`${data?.product.image_fullpath[0]}`} style={{height:"75%",width:"75%"}}/>
                      </div>
                    </div>
                  </div>
                  <div className="mt-24">
                    <div className="product-details__images-slider">
                       
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 px-50">
                <div className="product-details__content">
                  <h5 className="mb-12">{data?.product["name"]}</h5>

                  <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />

                  <div className="mt-32 flex-align flex-wrap gap-20">
                    <div className="flex-align gap-8">
                      <h4 className="mb-0">
                        Rs.
                        {calculateDiscountedPrice(
                          data?.product.price,
                          data?.product.discount,
                          data?.product.discount_type
                        )}
                      </h4>

                      <span className="text-md text-gray-500">
                        Rs.{data?.product.price}
                      </span>
                    </div>
                    
                      <button
                        className="btn btn-main rounded-pill"
                        onClick={decrementQuantity}
                        disabled={quantity <= 1} // Disable if quantity is 1
                      >
                        -
                      </button>
                      <input
                        type="text"
                        value={quantity}
                        readOnly
                        className="quantity-input text-center"
                        style={{width:"50px"}}
                      />
                      <button
                        className="btn btn-main rounded-pill"
                        onClick={incrementQuantity}
                      >
                        +
                      </button>
                     
                    <button
                      to="#"
                      className="btn btn-main rounded-pill"
                      onClick={() => {
                        addToCart(data.product.id,quantity);
                      }}
                    >
                      Add to Cart
                    </button>
                    <button to="#" className="btn btn-main rounded-pill">
                      Add to Wishlist
                    </button>
                  </div>
                  <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                  <div className="pt-3">
                    <div className="product-dContent border rounded-24">
                      <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-16">
                        <ul
                          className="nav common-tab nav-pills mb-3"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link active"
                              id="pills-description-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-description"
                              type="button"
                              role="tab"
                              aria-controls="pills-description"
                              aria-selected="true"
                            >
                              Description
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link"
                              id="pills-reviews-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-reviews"
                              type="button"
                              role="tab"
                              aria-controls="pills-reviews"
                              aria-selected="false"
                            >
                              Reviews
                            </button>
                          </li>
                        </ul>
                        <Link
                          to="#"
                          className="btn bg-color-one rounded-16 flex-align gap-8 text-main-600 hover-bg-main-600 hover-text-white"
                        >
                          <img
                            src="assets/images/icon/satisfaction-icon.png"
                            alt=""
                          />
                          100% Satisfaction Guaranteed
                        </Link>
                      </div>
                      <div className="product-dContent__box">
                        <div className="tab-content" id="pills-tabContent">
                          <div
                            className="tab-pane fade show active"
                            id="pills-description"
                            role="tabpanel"
                            aria-labelledby="pills-description-tab"
                            tabIndex={0}
                          >
                            <div className="mb-40">
                              <h6 className="mb-24">Product Description</h6>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: data?.product?.description,
                                }}
                              ></div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="pills-reviews"
                            role="tabpanel"
                            aria-labelledby="pills-reviews-tab"
                            tabIndex={0}
                          >
                            <div className="row g-4"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsOne;
